<section class="p-6">

    <!--
    <app-industry-landscape [company]="company"
                            [edit]="edit">
    </app-industry-landscape>
    -->

    <app-special-information [reportSearch]="reportSearch"
                             [company]="company">
    </app-special-information>

</section>
